import { Injectable, inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import {
    ModalController,
    ToastController,
    AlertController,
    LoadingController
} from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AuthCleanupService {

    private router = inject(Router);
    private ngZone = inject(NgZone);
    private modalCtrl = inject(ModalController);
    private toastCtrl = inject(ToastController);
    private alertCtrl = inject(AlertController);
    private loadingCtrl = inject(LoadingController);

    async handle401(): Promise<void> {
        await this.closeAllOverlays();

        localStorage.removeItem('jwtToken');
        localStorage.removeItem('jwtExpires');
        localStorage.removeItem('userData');

        this.ngZone.run(() => {
            this.router.navigate(['/login']);
        });
    }

    private async closeAllOverlays(): Promise<void> {
        try {
            await this.modalCtrl.dismiss().catch(() => {});
            const alert = await this.alertCtrl.getTop();
            if (alert) await this.alertCtrl.dismiss();
            const toast = await this.toastCtrl.getTop();
            if (toast) await this.toastCtrl.dismiss();
            const loader = await this.loadingCtrl.getTop();
            if (loader) await this.loadingCtrl.dismiss();
        } catch (err) {
            console.warn('Overlay closing error', err);
        }
    }
}